import React from "react";
import MainLayout from "./MainLayout";
import ReferencesPage from "../common/OnBoarding/OnBoardingReferences";

const References = (props) => <MainLayout component={ReferencesPage} />;

export default References;
